import { Fragment, h, JSX } from 'preact'

import { Pagination, PaginationProps } from '../../components/pagination/pagination'
import {
    ProductListItem,
    ProductListItemProps,
} from '../../components/product-list-item/product-list-item'

interface NoResultsProps {
    texts: {
        noResults: string
        tryAnotherSearch: string
        removeFilters: string
    }
    removeFilters: () => void
}

export interface ProductsListSectionProps {
    productsByCategories: Record<string, ProductListItemProps[]>
    pagination?: PaginationProps
    noResults?: NoResultsProps
}

export const ProductsListSection = (props: ProductsListSectionProps): JSX.Element => (
    <div className="checkout__section">
        <div className="checkout__section-content">
            {props.noResults ? (
                <div className="checkout__no-results">
                    <div>{props.noResults.texts.noResults}</div>
                    <div>
                        {props.noResults.texts.tryAnotherSearch}{' '}
                        <span
                            onClick={props.noResults.removeFilters}
                            className="no-results__action"
                        >
                            {props.noResults.texts.removeFilters}
                        </span>
                        .
                    </div>
                </div>
            ) : (
                <div className="checkout__products">
                    {Object.entries(props.productsByCategories).map(
                        ([category, products], index) => (
                            <Fragment key={index}>
                                <h3 className="checkout__products-title">{category}</h3>
                                {products.map((product: ProductListItemProps) => (
                                    <ProductListItem key={product.id} {...product} />
                                ))}
                            </Fragment>
                        ),
                    )}
                    {props.pagination && <Pagination {...props.pagination} />}
                </div>
            )}
        </div>
    </div>
)
